<app-lex-xi-side-panel
  [isLoading]="isLoading"
  [selectedItem]="selectedProject"
  [rightPlaceholder]="projectsRightPlaceholder"
  [panelOpen]="isPanelOpen"
  [verticalTabBarData]="[
    {
      id: 'list_view',
      icon: 'list_view',
      hasSeparator: true,
      leftSideTemplate: leftSide,
      rightSideTemplate: rightSide,
    },
  ]"
  (open)="onPanelStateChange(true)"
  (close)="onPanelStateChange(false)"
></app-lex-xi-side-panel>

<ng-template #leftSide>
  <div side="left" class="project-list__list-wrapper" *transloco="let t; read: 'project-list'">
    <div class="project-list__action-list-container">
      <div class="project-list__project-list-header">
        <h3 class="project-list__project-list-label">{{ t('projects') }}</h3>

        @if (showCreateProject && projectList.length) {
          <xi-fab
            icon="fab_plus"
            color="orca"
            buttonSize="normal"
            [tooltip]="{ text: createProjectTooltip, direction: 12 }"
            [disabled]="!canCreateProject"
            (onClick)="createProject()"
          >
          </xi-fab>
        }
      </div>

      <div class="project-list__scroll">
        @if (projectList.length && !isLoading) {
          <xi-list
            select="single"
            size="large"
            [hasSearch]="true"
            [hasDragging]="false"
            [hasBorder]="false"
            [internalProps]="internalProps"
            [value]="selectedProject"
          >
            <div slot="children">
              @if (filteredProjects.length > 0) {
                <div class="project-list__list-sort-dropdown">
                  <xi-dropdown
                    [placeholder]="t['sort-projects']"
                    select="single"
                    [value]="projectsSort"
                    [data]="projectsListSortData"
                    (onValueChange)="onSortProjectsList($event.detail.selected.id)"
                  ></xi-dropdown>
                </div>
              }
              <div>
                @for (project of filteredProjects; track project) {
                  <div class="project-list__list-item-container">
                    <xi-list-item
                      [checked]="selectedProject === project"
                      [attr.id]="project.id"
                      [value]="project.id"
                      [disabled]="projectListHandlerService.shouldListBeDisabled()"
                      (onItemClick)="onProjectSelected(project, $event)"
                      [ngClass]="
                        selectedProject === project
                          ? '
              kxi-text-600'
                          : ''
                      "
                    >
                      <div slot="children" class="project-list__list-item-text">
                        <div
                          class="kxi-text-normal project-list__list-item-name"
                          matTooltip="{{ project.name }}"
                          [matTooltipDisabled]="!(project.name.length >= 30)"
                        >
                          {{ project.name | truncate: 30 }}
                        </div>
                        <p class="kxi-text-xsmall project-list__list-item-text-modified-date">
                          {{ t('modified', { date: (project.modifiedAt | lexDate: 'long') }) }}
                        </p>
                        <p class="kxi-text-xsmall project-list__list-item-text-document-count">
                          {{ t('doc-count', { count: (project.documentCount | number) }) }}
                        </p>
                      </div>
                    </xi-list-item>
                  </div>
                }
              </div>
            </div>
          </xi-list>
        }
        @if (!projectList.length && !isLoading) {
          <app-empty-side-panel
            emptyViewText="{{ t('empty-text') }}"
            [emptyViewSvg]="showCreateProject ? 'plus' : ''"
            [emptyViewTitle]="showCreateProject ? t('empty-title') : ''"
            ctaButtonText="{{ t('empty-cta-btn-text') }}"
            [showCtaButton]="showCreateProject"
            [isCtaBtnDisabled]="!canCreateProject"
            (ctaButtonClick)="createProject()"
          ></app-empty-side-panel>
        }
      </div>
    </div>
  </div>
</ng-template>

<ng-template #rightSide>
  <div side="right">
    <router-outlet></router-outlet>
  </div>
</ng-template>
